import { useEffect, useState } from 'react';
import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';
import DashboardNavbar from './DashboardNavbar';
import PSCDashboardSidebar from './PSCDashboardSidebar';
import * as GuestService from '../../UIS_services/GuestService/index';

interface DashboardLayoutProps {
  children?: ReactNode;
}

interface IFooterInfo {
  SettingName: string,
  SettingStringData: string
}
const ArrayInfo = [
  "TenTruong",
//   "DiaChiTruong",
//   "DienThoaiTruong",
//   "EmailTruong",
//   "Website",
//   "SoFax",
]


const DashboardLayoutRoot = experimentalStyled('div')(
  ({ theme }) => (
    {
      backgroundColor: theme.palette.background.default,
      display: 'flex',
      height: '100%',
      overflow: 'hidden',
      width: '100%'
    }
  )
);

const DashboardLayoutWrapper = experimentalStyled('div')(
  ({ theme }) => (
    {
      display: 'flex',
      flex: '1 1 auto',
      overflow: 'hidden',
      paddingTop: '64px',
      [theme.breakpoints.up('lg')]: {
        paddingLeft: '280px'
      }
    }
  )
);

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  WebkitOverflowScrolling: 'touch'
});

const DashboardLayout: FC<DashboardLayoutProps> = () => {
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState<boolean>(false);
  const [HeaderInfo, setHeaderInfo] = useState<IFooterInfo[]>([] as IFooterInfo[]);
  
  async function LoadHeaderInfo() {
    let data = await GuestService.footerService.Getfooterinfor();
    let NewArraydataInfo: IFooterInfo[] = [];
    data.forEach(el => {
      let item = ArrayInfo.indexOf(el.SettingName);
      if (item != -1) {
        NewArraydataInfo.push(el);
      }
    });
    setHeaderInfo(NewArraydataInfo);
  
  }
  useEffect(() => {
    if (HeaderInfo.length == 0) {
      LoadHeaderInfo();
    }
  }, [])

  return (
    <DashboardLayoutRoot>
      <DashboardNavbar
        onSidebarMobileOpen={(): void => setIsSidebarMobileOpen(true)}
        headerData ={HeaderInfo}
      />
      <PSCDashboardSidebar
        onMobileClose={(): void => setIsSidebarMobileOpen(false)}
        openMobile={isSidebarMobileOpen}
      />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
